import { FormattedMessage } from 'react-intl';
import { Participant } from '../../types';

function primaryParticipant(participants: Participant[]): Participant | null {
  let lowest: Participant | null = null;
  for (const candidate of participants) {
    if (lowest == null || candidate.position < lowest.position) {
      lowest = candidate;
    }
  }
  return lowest;
}

interface Props {
  participants: Participant[];
  tone: string;
}

export default function Applicant({ participants, tone }: Props) {
  const primary = primaryParticipant(participants);
  if (primary == null) return null;

  const extra = participants.length - 1;
  return (
    <p className={`text-sm ${tone}`}>
      {primary.name}
      {extra > 0 && (
        <span className="ml-1 text-slate-400">
          <FormattedMessage id="schedule.list.applicantExtra" values={{ count: extra }} />
        </span>
      )}
    </p>
  );
}
